import React from 'react';
import {
  Drawer,
  DrawerProps,
  Button,
  Panel,
  Stack,
  Radio,
  FlexboxGrid,
  Col,
  Divider,
  Checkbox
} from 'rsuite';

const Card = props => (
  <Panel {...props} bordered style={{ width: 165 }}>
    <Radio>Autogenerate</Radio>
  </Panel>
);
const Card1 = props => (
  <Panel {...props} bordered style={{ width: 165 }}>
    <Radio>Sort the products by</Radio>
  </Panel>
);

const DrawerVieweee = (props: DrawerProps) => {

  const { onClose, ...rest } = props;
  return (
    <Drawer backdrop="static" size="xs" placement="left" onClose={onClose} {...rest}>
      <Drawer.Header>
        <Drawer.Actions>
          <Button onClick={onClose} appearance="ghost" color='cyan'>
            Previous
          </Button>
          <Button color="cyan" onClick={onClose} appearance="primary">
            Done
          </Button>
        </Drawer.Actions>
      </Drawer.Header>
      <Drawer.Body>
        <Panel >
          <div style={{ marginBottom: '22px', marginLeft: '-7px' }}>
            <b> Preview</b>
          </div>
          <label>Recommended for landscape images</label>
        </Panel>
        <FlexboxGrid justify="space-between" style={{ marginTop: '20px' }}>
          <FlexboxGrid.Item as={Col} colspan={24} md={12}>
            <Card />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} md={12}>
            <Card1 />
          </FlexboxGrid.Item>
        </FlexboxGrid>
        <Divider />
        <Stack direction='column' alignItems='flex-start'>
          <Checkbox>Set as default template</Checkbox>
          <label>This will be preselected as a default template for all catalogues. You can always update this.</label>
        </Stack>
      </Drawer.Body>
    </Drawer>
  );
};

export default DrawerVieweee;